import { CarrierVisitStatus } from '@planning/app/api'
import { CarrierVisitViewStatus } from '@planning/constants'
import { containerService } from '@planning/services'
import moment from 'moment'
import { IDateRange, IElementWithId, IEntityMap, IdType } from './types'

export const getMidnightTime = (value: Date) => {
  return moment(value).startOf('d').toDate()
}

export const getEndOfDayTime = (value: Date) => {
  return moment(value).endOf('d').toDate()
}

export const calculateDateRangeDiff = (range1: IDateRange, range2: IDateRange) => {
  // fetch data before the current data range
  if (range2.from < range1.from && range2.to <= range1.to) {
    return {
      from: getMidnightTime(range2.from),
      to: getEndOfDayTime(range1.from),
    }
  }

  // fetch data after the current data range
  if (range2.to > range1.to && range2.from >= range1.from) {
    return {
      from: getMidnightTime(range1.to),
      to: getEndOfDayTime(range2.to),
    }
  }

  // default case for both are smaller or bigger than the current data range
  return {
    from: getMidnightTime(range2.from > range1.from ? range1.from : range2.from),
    to: getEndOfDayTime(range2.to > range1.to ? range2.to : range1.to),
  }
}

export const groupById = <T extends IElementWithId<IdType>>(elems: T[]) => {
  return elems.reduce((acc, cur) => {
    acc[cur.id] = cur
    return acc
  }, {} as IEntityMap<T>)
}

export const validateContainerNumber = (containerNumber: string) => {
  const regex = /^[A-Z]{3}[UJZ][0-9]{7}$/
  return !!containerNumber.toUpperCase().match(regex)
}

export const validateUnitNumber = (unitNumber: string) => {
  const regex = /^[A-Z]{4}[0-9]{7}$/
  return !!unitNumber.toUpperCase().match(regex)
}

export const validateIsoCode = async (isoCode: string) => {
  const invalidIsoCodes = await containerService.validateIsoCodes([isoCode])
  return invalidIsoCodes.length === 0
}

export const getCarrierVisitViewStatus = (status: CarrierVisitStatus, atb?: string | null) => {
  if (status === CarrierVisitStatus.Departed) return CarrierVisitViewStatus.Departed

  if (status === CarrierVisitStatus.Completed) return CarrierVisitViewStatus.Completed

  if (status === CarrierVisitStatus.InOperation) return CarrierVisitViewStatus.InOperation

  if (status === CarrierVisitStatus.Closed) return CarrierVisitViewStatus.Closed

  if (atb) return CarrierVisitViewStatus.Berthed

  return status
}
